import styles from '../css/CopyrightHolders.module.css';

const PrivacyPolicy = () => {
  return (
    <div className={styles.copyrightPage}>
      <div className={styles.container}>
        <h1 className={styles.title}>Политика конфиденциальности</h1>

        <div className={styles.content}>
          <p className={styles.paragraph}>
            Настоящая Политика конфиденциальности описывает, как сайт DoramaHype (doramahype.ru)
            собирает, использует и защищает информацию, которую вы предоставляете при использовании нашего сервиса.
            Используя сайт, вы соглашаетесь с условиями данной политики.
          </p>

          <div className={styles.requirements}>
            <h2 className={styles.subtitle}>Какие данные мы собираем</h2>
            <ul className={styles.list}>
              <li>Данные аккаунта: имя пользователя, email-адрес при регистрации через Google OAuth.</li>
              <li>Данные об использовании: страницы, которые вы посещаете, история просмотров дорам, закладки и оценки.</li>
              <li>Технические данные: IP-адрес, тип браузера, операционная система, файлы cookie.</li>
              <li>Данные от рекламных партнёров: Google AdSense может собирать данные для показа персонализированной рекламы.</li>
            </ul>
          </div>

          <div className={styles.requirements}>
            <h2 className={styles.subtitle}>Как мы используем данные</h2>
            <ul className={styles.list}>
              <li>Обеспечение работы сайта и персонализация контента (история, закладки, рекомендации).</li>
              <li>Авторизация пользователей через Google OAuth.</li>
              <li>Показ рекламы через Google AdSense на основе ваших интересов.</li>
              <li>Анализ посещаемости и улучшение качества сервиса.</li>
              <li>Связь с пользователями по вопросам, связанным с аккаунтом.</li>
            </ul>
          </div>

          <div className={styles.requirements}>
            <h2 className={styles.subtitle}>Файлы cookie</h2>
            <p className={styles.paragraph}>
              Мы используем файлы cookie для сохранения сессии авторизации и пользовательских настроек.
              Наш рекламный партнёр Google AdSense также использует cookie для показа релевантной рекламы.
              Вы можете отключить cookie в настройках браузера, однако это может повлиять на функциональность сайта.
            </p>
            <p className={styles.paragraph}>
              Подробнее о том, как Google использует данные: <a href="https://policies.google.com/technologies/ads" target="_blank" rel="noopener noreferrer" style={{color: 'var(--accent-color)'}}>policies.google.com/technologies/ads</a>
            </p>
          </div>

          <div className={styles.requirements}>
            <h2 className={styles.subtitle}>Передача данных третьим лицам</h2>
            <p className={styles.paragraph}>
              Мы не продаём и не передаём ваши личные данные третьим лицам, за исключением:
            </p>
            <ul className={styles.list}>
              <li>Google LLC — для целей авторизации (Google OAuth) и показа рекламы (Google AdSense).</li>
              <li>Случаев, когда это требуется по закону или для защиты прав пользователей.</li>
            </ul>
          </div>

          <div className={styles.requirements}>
            <h2 className={styles.subtitle}>Защита данных</h2>
            <p className={styles.paragraph}>
              Мы принимаем технические меры для защиты ваших данных: передача данных осуществляется по протоколу HTTPS,
              пароли не хранятся (используется OAuth). Тем не менее, ни одна система передачи данных через интернет
              не является полностью защищённой.
            </p>
          </div>

          <div className={styles.requirements}>
            <h2 className={styles.subtitle}>Ваши права</h2>
            <ul className={styles.list}>
              <li>Запросить доступ к своим персональным данным.</li>
              <li>Потребовать удаления аккаунта и связанных данных.</li>
              <li>Отказаться от персонализированной рекламы в настройках Google.</li>
            </ul>
          </div>

          <p className={styles.paragraph}>
            По вопросам, связанным с конфиденциальностью, вы можете связаться с нами:
          </p>

          <p className={styles.email}>
            📧 doramahype@gmail.com
          </p>

          <p className={styles.paragraph}>
            Последнее обновление: апрель 2026 г.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
